const isItSetupIntent = (clientSecret?: null | string): boolean =>
  !!(clientSecret && clientSecret.match(/^seti_/));

export default isItSetupIntent;
